import socketio from "socket.io-client";
import React from "react";

export const socket = socketio(process.env.REACT_APP_URL, {
    // Don't connect automatically - components will call socket.connect() after setting auth headers
    autoConnect: false,

    // Force WebSocket transport (skip long-polling which causes Heroku timeout issues)
    transports: ['websocket'],
    upgrade: false,

    // Reconnection strategy
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,        // Start with 1 second delay
    reconnectionDelayMax: 10000,    // Max 10 seconds between attempts
    randomizationFactor: 0.5,       // Add jitter to prevent thundering herd

    // Connection timeout (under Heroku's 30s limit)
    timeout: 25000,
});

export const SocketContext = React.createContext();

// Debug handle — lets us inspect connection state and listen to events from the
// browser console without needing React DevTools. Dev-only so it doesn't leak
// the live socket onto window in production.
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
    window.__socket = socket;
}
